import { describe, expect, it } from 'vitest';

import substr from './substr'; // Adjust this import path accordingly

describe('substr function', () => {
  it('should return substring from start index to end index', () => {
    const result = substr('Hello, world!', 0, 5);
    expect(result).toBe('Hello');
  });

  it('should handle negative start index', () => {
    const result = substr('Hello, world!', -6, 5);
    expect(result).toBe('world');
  });

  it('should handle start index greater than string length', () => {
    const result = substr('Hello, world!', 20, 5);
    expect(result).toBe('');
  });

  it('should handle length greater than string length', () => {
    const result = substr('Hello', 0, 10);
    expect(result).toBe('Hello');
  });

  it('should return full string if length is not provided', () => {
    const result = substr('Hello, world!', 0);
    expect(result).toBe('Hello, world!');
  });

  it('should handle -Infinity as start index', () => {
    const result = substr('Hello, world!', -Infinity, 5);
    expect(result).toBe('Hello');
  });

  it('should return empty string if start and length are out of bounds', () => {
    const result = substr('Hello, world!', 100, 5);
    expect(result).toBe('');
  });

  it('should return substring within bounds if start is negative', () => {
    const result = substr('Hello, world!', -5, 3);
    expect(result).toBe('orl');
  });
});
